import { render, staticRenderFns } from "./compliance-letter-config.vue?vue&type=template&id=3cacc8ba&scoped=true"
import script from "./compliance-letter-config.vue?vue&type=script&lang=ts"
export * from "./compliance-letter-config.vue?vue&type=script&lang=ts"
import style0 from "./compliance-letter-config.vue?vue&type=style&index=0&id=3cacc8ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cacc8ba",
  null
  
)

export default component.exports